import React from "react";
import { GOOGLE_REVIEWS_URL } from "../../constants/gmb";
import { useGmbReviews } from "../../context/GmbReviewsContext";
import "./GoogleRating.scss";

const STAR_IMAGE_URL =
  "https://www.pngplay.com/wp-content/uploads/6/Golden-5-Star-Rating-PNG.png";

export default function GoogleRating({ variant = "hero" }) {
  const { displayRating, ratingCount, hasData, loading } = useGmbReviews();

  if (loading && !hasData) {
    return (
      <div className="heroDataBottomDiv googleRatingLoading">
        <div className="heroDataLeft">
          <p className="heroSubTxt">Loading Google reviews…</p>
        </div>
      </div>
    );
  }

  if (!hasData) {
    return null;
  }

  const primaryText =
    variant === "footer"
      ? `${displayRating} on Google`
      : `${displayRating} on Google`;

  const secondaryText =
    variant === "footer"
      ? `${ratingCount} reviews`
      : `${ratingCount} reviews`;

  return (
    <a
      href={GOOGLE_REVIEWS_URL}
      target="_blank"
      rel="noopener noreferrer"
      className={`googleRatingLink googleRatingLink--${variant}`}
    >
      <div className="heroDataBottomDiv">
        <div className="heroDataLeft">
          <p className="heroSubTxt">{primaryText}</p>
          {variant === "hero" && (
            <p className="heroMiniSubTxt">{secondaryText}</p>
          )}
          {variant === "footer" && (
            <p className="heroMiniSubTxt footerRatingCount">{secondaryText}</p>
          )}
        </div>
        <div className="heroDataRight">
          <img src={STAR_IMAGE_URL} alt="Google star rating" className="ratingStarImg" />
        </div>
      </div>
    </a>
  );
}
